/*eslint-disable*/
import {mapState} from "vuex";
import continents from "../../config/continents";
import {fr, ru} from "vuejs-datepicker/dist/locale";

const pathToLocationsNames = 'components/motivation/map/map-assets/elements/locations-names/';
const availableLanguages = ['ru', 'fr'];

export default {
    props: {
        city: {
            type: String,
            require: true
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user
        }),
        continent() {
            return continents[this.city];
        },
        locale() {
            if (this.user && this.user.locale) {
                return availableLanguages.includes(this.user.locale) ? this.user.locale : 'ru';
            }
            return 'ru';
        },
        componentPath() {
            return `${pathToLocationsNames + this.locale}/${this.continent}/${this.city.replace("-", "")}`;
            },
        componentFile() {
            return () => import('../../' +  this.componentPath + '.vue');
        }
    },
}